import {BaseSuggestionModel} from "./base-suggestion.model";
import {LocationSuggestionModel} from "./location-suggetion.model";

export class SmartSuggestService {
    public static getSuggestionElements(suggestions: Array<BaseSuggestionModel>, title: string): Array<string>{
        const elements = new Array<string>();
        if (!suggestions || !suggestions.length) {
            return elements;
        }

        const linkableSuggestions = suggestions.filter(x => !!x.url);
        if (!linkableSuggestions.length) {
            return elements;
        }

        elements.push(`<h2 class="pcg-smart-search__category">${title}</h2>`);
        elements.push("<ul class='pcg-smart-search__list'>");

        linkableSuggestions.forEach(x => {
            elements.push(`
            <li class="pcg-smart-search__item">
                <a href="${x.url}" class="pcg-smart-search__link pcg-smart-search__link--${x.colorClass}">${x.name}</a>
            </li>`);
        });

        elements.push("</ul>");
        return elements;
    }

    public static getShowMoreElement(searchPageUrl: string): string {
        return `
            <a href="${searchPageUrl}" class="pcg-smart-search__see-all">See all results</a>
        `;
    }

    public static getLocationSuggestionElements(locationSuggestions: Array<LocationSuggestionModel>, selectedLocations: Set<string>): Array<string>{
        const elements = new Array<string>();
        if (!locationSuggestions || !locationSuggestions.length) {
            return elements;
        }

        locationSuggestions.forEach(x => {
            const isChecked = selectedLocations.has(x.id) ? "checked" : "";
            elements.push(`
            <li>
                <label class="pcg-custom-checkbox pcg-custom-checkbox--reverse">
                    <input type="checkbox" value="${x.id}" ${isChecked}>
                    <span class="pcg-custom-checkbox__text">${x.name}</span>
                </label>
            </li>`);
        });
        return elements;
    }
}
